module.exports = __webpack_public_path__ + "static/media/pasamosagosto4.5f99498b.jpg";